import { render, staticRenderFns } from "./FAQItem.vue?vue&type=template&id=3215df8c&scoped=true&"
import script from "./FAQItem.vue?vue&type=script&lang=js&"
export * from "./FAQItem.vue?vue&type=script&lang=js&"
import style0 from "./FAQItem.vue?vue&type=style&index=0&id=3215df8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3215df8c",
  null
  
)

export default component.exports